import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createContext, useReducer } from 'react';
export var actions = {
  setFacilityInfoAction: function setFacilityInfoAction(info) {
    return {
      type: 0
      /* SET_FACILITY_INFO */
      ,
      data: info
    };
  },
  setFacilityAlertsAction: function setFacilityAlertsAction(alerts) {
    return {
      type: 1
      /* SET_FACILITY_ALERTS */
      ,
      data: alerts
    };
  },
  setFacilityPromotions: function setFacilityPromotions(promotions) {
    return {
      type: 2
      /* SET_FACILITY_PROMOTIONS */
      ,
      data: promotions
    };
  }
};
export var initialState = {
  alerts: [],
  workingHours: {},
  promotions: []
}; // Reducer

export var reducer = function reducer(state, action) {
  switch (action.type) {
    case 1
    /* SET_FACILITY_ALERTS */
    :
      return _objectSpread(_objectSpread({}, state), {}, {
        alerts: action.data
      });

    case 0
    /* SET_FACILITY_INFO */
    :
      return _objectSpread({}, action.data);

    case 2
    /* SET_FACILITY_PROMOTIONS */
    :
      return _objectSpread(_objectSpread({}, state), {}, {
        promotions: action.data
      });

    default:
      return state;
  }
};
export var FacilityContext = createContext({
  state: initialState,
  dispatch: function dispatch(a) {
    return reducer(initialState, a);
  }
});

var initReducer = function initReducer() {
  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  FacilityContext = createContext({
    state: state,
    dispatch: dispatch
  });
};

export default initReducer;